import { AChartComponent } from "../../achart/achart.component";

import { Workspace } from "../../../model/workspace.data";

import { IIndicator, IIndicatorInstance, DeepCopyIndicators } from "../../achart/indicators";

import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { MobileIndicatorModalComponent } from "../mobile-indicator-modal/mobile-indicator-modal.component";

import { IndicatorModalComponent } from "./IndicatorModal.component";

import { FormGroup } from "@angular/forms";
import { ChartDisplayMode } from "../../../enums/ChartDisplayMode.list";

export function ShowIndicatorModal(
    achart: AChartComponent,
    workspace: Workspace,
    indicator: IIndicator,
    index: number,
    modalService: NgbModal
) {
    const mobile = workspace.mobileMode != "desktop";
    const component = mobile ? MobileIndicatorModalComponent : IndicatorModalComponent;
    const windowClass = "dark-modal" + (mobile ? " mobile" : "");
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass
    };
    if (indicator.defaults.item.length <= 3) {
        opt.size = "sm";
    }
    let m: NgbModalRef = modalService.open(component, opt);

    var indicatorInstances = achart.indicatorInstances[indicator.type] || [];
    var defaultIndicator: IIndicator = {
        type: indicator.type,
        group: indicator.group,
        title: indicator.title,
        abbreviation: indicator.abbreviation,
        description: indicator.description,
        defaults: {
            item: []
        }
    };
    var definition =
        indicatorInstances.length > 0 && index < indicatorInstances.length && index >= 0
            ? indicatorInstances[index]
            : <IIndicatorInstance>{
                  title: `${indicatorInstances.length + 1} ${indicator.title}`,
                  indicator: defaultIndicator
              };

    if (definition.indicator.defaults.item.length == 0) {
        indicator.defaults.item.forEach(x => {
            let param = {
                name: x.name,
                value: x.value,
                type: x.type,
                color: x.color,
                width: x.width,
                array: x.array
            };
            definition.indicator.defaults.item.push(param);
        });
    }

    (<IndicatorModalComponent>m.componentInstance).initForm(
        definition.indicator,
        index < 0,
        Number(definition.selectedHeight || 25),
        achart.BackgroundColor
    );

    (<IndicatorModalComponent>m.componentInstance).columnClass =
        indicator.defaults.item.length <= 3 ? "col-6" : "col-4";

    let modalWindow = <IndicatorModalComponent>m.componentInstance;
    m.result
        .then((formGroup: FormGroup) => {
            definition.indicator.defaults.item.forEach(item => {
                let val: any = formGroup.value[item.name];
                val = val == "true" || val == "false" ? val == "true" : val;
                item.value = val;

                if (item.name.toLowerCase().includes("seriestype")) {
                    let currentColor = modalWindow.colorFixChange[`${item.name}_color`];
                    let currentColorArea = modalWindow.colorFixChange[`${item.name}_colorArea`];

                    let color: any = currentColor; // formGroup.value[`${item.name}_color`];
                    let colorArea: any = formGroup.value[`${item.name}_colorArea`];
                    let width: any = formGroup.value[`${item.name}_width`];

                    item.color = color || item.color;
                    item.colorArea = colorArea || item.colorArea;
                    item.width = width || item.width;
                }
            });

            definition.indicator.defaults.basedOn = formGroup.value["basedOn"] || "close";

            definition.selectedHeight = formGroup.value["selectedHeight"];

            if (formGroup.value["addToAllCharts"] == true) {
                Object.keys(workspace.charts).forEach(k => {
                    var cfg = workspace.charts[k];
                    var chart = <AChartComponent>cfg.instance;
                    if (chart && chart != achart) {
                        //HERE ADDING TO SELECTED CHART IS STOPPED TO AVOID UNNECESSARY COPYING DEFINITION OF INDICATOR

                        var tmp: IIndicatorInstance = JSON.parse(JSON.stringify(definition));
                        tmp.indicator.defaults = JSON.parse(JSON.stringify(definition.indicator.defaults));
                        tmp.enabled = true;
                        chart.indicatorInstances[indicator.type] = chart.ShowIndicatorInstance(
                            tmp,
                            index,
                            chart.indicatorInstances[indicator.type]
                        );
                        chart.updateIndicatorsPlotHeight(definition.selectedHeight || "25");
                        chart.saveUserIndicators();
                        chart.drawIndicatorTab();
                    } else {
                        var tmp: IIndicatorInstance = JSON.parse(JSON.stringify(definition));
                        tmp.indicator.defaults = JSON.parse(JSON.stringify(definition.indicator.defaults));
                        switch (workspace.chartDisplayMode) {
                            case ChartDisplayMode.CHARTING:
                                cfg.chartIndicatorInstances[indicator.type] =
                                    cfg.chartIndicatorInstances[indicator.type] || [];
                                cfg.chartIndicatorInstances[indicator.type].push({
                                    enabled: true,
                                    indicator: tmp.indicator,
                                    title: ""
                                });
                                break;
                            case ChartDisplayMode.ENTSIGNALS:
                                break;
                            case ChartDisplayMode.WIZARD:
                                cfg.wizardIndicatorInstances[indicator.type] =
                                    cfg.wizardIndicatorInstances[indicator.type] || [];
                                cfg.wizardIndicatorInstances[indicator.type].push({
                                    enabled: true,
                                    indicator: tmp.indicator,
                                    title: ""
                                });
                                break;
                        }
                        var wizInd = DeepCopyIndicators([cfg.wizardIndicatorInstances]);
                        var chartInd = DeepCopyIndicators([cfg.chartIndicatorInstances]);
                        workspace.setToUserStore(`wizIndicators_${k}`, JSON.stringify(wizInd));
                        workspace.setToUserStore(`chartIndicators_${k}`, JSON.stringify(chartInd));
                    }
                });
            }
            //DO NOT ADD ELSE
            definition.enabled = true;
            achart.indicatorInstances[indicator.type] = achart.ShowIndicatorInstance(
                definition,
                index,
                indicatorInstances
            );
            achart.updateIndicatorsPlotHeight(definition.selectedHeight || "25");
            achart.saveUserIndicators();
            achart.drawIndicatorTab();

            achart.workspace.save();
        })
        .catch(e => {
            console.error(e);
        });
}
